// Configuration centralisée de l'application
// Utilise la variable d'environnement si disponible, sinon la valeur par défaut
export const API_URL = process.env.REACT_APP_API_URL || 'https://famibox.cazapp.fr:3000';
